import {
    Component,
    forwardRef,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors,
    Validator,
    Validators,
} from '@angular/forms';
import { IOption } from '@cmps/ng-select';

import { Option } from '../../core';

@Component({
    selector: 'cmps-eval-reason',
    templateUrl: './reason.component.html',
    host: {
        class: 'cmps-eval-reason',
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReasonComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ReasonComponent),
            multi: true,
        },
    ],
})
export class ReasonComponent
    implements OnChanges, ControlValueAccessor, Validator
{
    @Input() options: Option[];

    @Input() optionId: number;

    /** @private */
    _option: Option;

    /** @private */
    _reasonOpts: IOption[];

    /** @private */
    _reasonValue: string;

    /** @private */
    _isDisabled: boolean;

    private _onChange: (_: any) => void;
    private _onTouched: () => void;

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('options') ||
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty('optionId')
        ) {
            this._option = this.options?.find(
                (e) => e.optionId === this.optionId,
            );
            this._reasonOpts = this._option?.reason?.options?.map<IOption>(
                ({ value, label }) => ({ value, label }),
            );
        }

        /** needs to be without this._reasonValue != null for the validator */
        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            changes.hasOwnProperty(
                'optionId',
            ) /* && this._reasonValue != null */
        ) {
            this._reasonValue = null;
            this._onChange?.(null);
        }
    }

    registerOnChange(fn: (_: any) => void): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this._onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this._isDisabled = isDisabled;
    }

    writeValue(obj: string): void {
        this._reasonValue = obj;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this._option?.reason?.required) {
            return Validators.required(control);
        }
        return null;
    }

    /** @private */
    _onOptionChange(value: string): void {
        this._onChange?.(value);
    }
}
